import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import PdfViewerComponent from '../media/pdf-viewer';

interface MediaPreviewDialogProps {
  title: string;
  mediaType: string;
  mediaUrl: string;
  onClose: () => void;
}

const MediaPreviewDialog: React.FC<MediaPreviewDialogProps> = ({
  title,
  mediaType,
  mediaUrl,
  onClose
}) => {
  return (
    <Dialog closeIcon title={title} onClose={onClose}>
      {mediaType === 'video' ? (
        <video
          key={mediaUrl}
          className="video"
          controls
          style={{
            maxHeight: '600px'
          }}>
          <source src={mediaUrl} type="video/mp4"></source>
        </video>
      ) : mediaType === 'image' ? (
        <img className={'w-100 h-100'} src={mediaUrl} alt="" />
      ) : mediaType === 'audio' ? (
        <audio src={mediaUrl} controls autoPlay>
          <source src={mediaUrl} type="audio/mpeg" />
        </audio>
      ) : mediaType == 'pdf' ? (
        <PdfViewerComponent source={mediaUrl}></PdfViewerComponent>
      ) : (
        ['youtube', 'vimeo'].includes(mediaType) && (
          <iframe
            src={
              mediaType === 'youtube'
                ? `https://www.youtube.com/embed/${mediaUrl}`
                : `https://player.vimeo.com/video/${mediaUrl}`
            }
            width={500}
            height={250}
            referrerPolicy={'strict-origin-when-cross-origin'}
            allow={
              'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
            }
            allowFullScreen
          />
        )
      )}
    </Dialog>
  );
};

export default MediaPreviewDialog;
